import styled from 'styled-components';

export const StyledImage = styled.img`
  width: 100%;
  margin-bottom: 8px;
`;
